var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _g2, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 449.999984",
    height: 600,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4982d56d99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128 57.46875 L 297 57.46875 L 297 170 L 128 170 Z M 128 57.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9dfbfb7252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 124 L 380.25 124 L 380.25 392.71875 L 45 392.71875 Z M 45 124 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 173.511719 185.984375 L 123.226562 185.984375 L 123.226562 197.15625 L 173.511719 197.15625 L 173.511719 185.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 123.226562 219.507812 L 156.75 219.507812 L 156.75 208.332031 L 123.226562 208.332031 L 123.226562 219.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 207.039062 208.332031 L 167.925781 208.332031 L 167.925781 219.507812 L 207.039062 219.507812 L 207.039062 208.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 123.226562 241.859375 L 134.398438 241.859375 L 134.398438 230.683594 L 123.226562 230.683594 L 123.226562 241.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 207.039062 230.683594 L 145.574219 230.683594 L 145.574219 241.859375 L 207.039062 241.859375 L 207.039062 230.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 156.75 253.03125 L 123.226562 253.03125 L 123.226562 264.207031 L 156.75 264.207031 L 156.75 253.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 207.039062 253.03125 L 167.925781 253.03125 L 167.925781 264.207031 L 207.039062 264.207031 L 207.039062 253.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 123.226562 286.558594 L 145.574219 286.558594 L 145.574219 275.382812 L 123.226562 275.382812 L 123.226562 286.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 207.039062 275.382812 L 156.75 275.382812 L 156.75 286.558594 L 207.039062 286.558594 L 207.039062 275.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 251.738281 230.683594 L 218.210938 230.683594 L 218.210938 241.859375 L 251.738281 241.859375 L 251.738281 230.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 218.210938 286.558594 L 251.738281 286.558594 L 251.738281 275.382812 L 218.210938 275.382812 L 218.210938 286.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 112.050781 208.332031 L 100.875 208.332031 L 100.875 219.507812 L 112.050781 219.507812 L 112.050781 208.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 112.050781 230.683594 L 100.875 230.683594 L 100.875 241.859375 L 112.050781 241.859375 L 112.050781 230.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 112.050781 253.03125 L 100.875 253.03125 L 100.875 264.207031 L 112.050781 264.207031 L 112.050781 253.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 100.875 286.558594 L 112.050781 286.558594 L 112.050781 275.382812 L 100.875 275.382812 L 100.875 286.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 112.050781 185.984375 L 100.875 185.984375 L 100.875 197.15625 L 112.050781 197.15625 L 112.050781 185.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 313.199219 219.507812 L 324.375 219.507812 L 324.375 208.332031 L 313.199219 208.332031 L 313.199219 219.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 313.199219 241.859375 L 324.375 241.859375 L 324.375 230.683594 L 313.199219 230.683594 L 313.199219 241.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 313.199219 264.207031 L 324.375 264.207031 L 324.375 253.03125 L 313.199219 253.03125 L 313.199219 264.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 313.199219 286.558594 L 324.375 286.558594 L 324.375 275.382812 L 313.199219 275.382812 L 313.199219 286.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 324.375 185.984375 L 313.199219 185.984375 L 313.199219 197.15625 L 324.375 197.15625 L 324.375 185.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4982d56d99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 285.261719 158.046875 L 139.988281 158.046875 L 139.988281 68.644531 L 285.261719 68.644531 Z M 296.4375 163.632812 L 296.4375 63.058594 C 296.4375 59.980469 293.925781 57.46875 290.851562 57.46875 L 134.398438 57.46875 C 131.324219 57.46875 128.8125 59.980469 128.8125 63.058594 L 128.8125 163.632812 C 128.8125 166.710938 131.324219 169.21875 134.398438 169.21875 L 290.851562 169.21875 C 293.925781 169.21875 296.4375 166.710938 296.4375 163.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 175.148438 139.644531 L 183.050781 131.746094 L 164.652344 113.34375 L 183.050781 94.945312 L 175.148438 87.046875 L 152.800781 109.394531 C 150.617188 111.578125 150.617188 115.113281 152.800781 117.296875 L 175.148438 139.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 250.101562 139.644531 L 272.449219 117.296875 C 274.632812 115.113281 274.632812 111.578125 272.449219 109.394531 L 250.101562 87.046875 L 242.199219 94.945312 L 260.597656 113.34375 L 242.199219 131.746094 L 250.101562 139.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 239.625 82.921875 L 230.324219 76.722656 L 185.625 143.769531 L 194.925781 149.96875 L 239.625 82.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9dfbfb7252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 369.074219 320.082031 C 369.074219 329.335938 361.566406 336.84375 352.3125 336.84375 L 72.9375 336.84375 C 63.683594 336.84375 56.175781 329.335938 56.175781 320.082031 L 56.175781 314.496094 L 369.074219 314.496094 Z M 251.738281 381.546875 L 173.511719 381.546875 L 173.511719 348.019531 L 251.738281 348.019531 Z M 352.3125 124.519531 L 307.613281 124.519531 L 307.613281 135.695312 L 352.3125 135.695312 C 361.566406 135.695312 369.074219 143.203125 369.074219 152.457031 L 369.074219 158.046875 L 307.613281 158.046875 L 307.613281 169.21875 L 369.074219 169.21875 L 369.074219 303.320312 L 56.175781 303.320312 L 56.175781 169.21875 L 117.636719 169.21875 L 117.636719 158.046875 L 56.175781 158.046875 L 56.175781 152.457031 C 56.175781 143.203125 63.683594 135.695312 72.9375 135.695312 L 117.636719 135.695312 L 117.636719 124.519531 L 72.9375 124.519531 C 57.527344 124.519531 45 137.050781 45 152.457031 L 45 320.082031 C 45 335.492188 57.527344 348.019531 72.9375 348.019531 L 162.335938 348.019531 L 162.335938 381.546875 L 128.8125 381.546875 L 128.8125 392.71875 L 296.4375 392.71875 L 296.4375 381.546875 L 262.914062 381.546875 L 262.914062 348.019531 L 352.3125 348.019531 C 367.722656 348.019531 380.25 335.492188 380.25 320.082031 L 380.25 152.457031 C 380.25 137.050781 367.722656 124.519531 352.3125 124.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#976db2",
    d: "M 209.21875 327.285156 C 209.21875 330.035156 211.46875 332.304688 214.238281 332.304688 C 216.988281 332.304688 219.261719 330.035156 219.261719 327.285156 C 219.261719 324.515625 216.988281 322.265625 214.238281 322.265625 C 211.46875 322.265625 209.21875 324.515625 209.21875 327.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.73d899557ffe01996dc1c9fa4db7a8fa.svg";
export { ForwardRef as ReactComponent };